module.exports = __webpack_public_path__ + "static/media/aws.5830aea3.svg";